import i18n from '@/utils/i18n'

export function notificationEventTypeLabel(eventType: string): string {
  const key = `notif.eventType.${eventType}`
  const label = i18n.t(key)
  return label === key ? eventType : label
}

export const TRIGGER_EVENT_TYPES = [
  'order.draft_published',
  'order.accepted',
  'order.assigned_to_inspector',
  'order.inspector_arrived',
  'order.inspection_started',
  'order.appraisal_ready',
  'order.appraisal_decision_required',
  'order.price_set',
  'order.dkp_sent',
  'order.dkp_correction_requested',
  'order.payment_sent',
  'order.delivery_decision_required',
  'order.delivery_started',
  'order.delivery_completed_awaiting_confirmation',
  'order.completed',
  'order.cancelled',
  'order.refused_by_inspector',
  'order.refused_by_seller',
  'order.buyout_refused',
] as const
